import type { IconType } from "react-icons";
import { FaInstagram, FaTwitch, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export const APP_NAME = "Focus.xyz";
export const APP_NAME_GENERIC = "Focus";
export const OPENFUND_APP_NAME = "Openfund";
export const DESO_APP_NAME = "DeSo";
export const DESO_TOKEN_NAME = `${DESO_APP_NAME} Token`;
export const TOKEN_DISPLAY_NAME = "$FOCUS";
export const DESO_TOKEN_DISPLAY_NAME = "DESO";
export const FOCUS_TOKEN_DISPLAY_NAME = "FOCUS";
export const USDC_DISPLAY_NAME = "USDC";
export const BTC_DISPLAY_NAME = "BTC";
export const ETH_DISPLAY_NAME = "ETH";
export const SOL_DISPLAY_NAME = "SOL";
export const DESO_TICKER_DISPLAY_NAME = "$DESO";
export const USDC_TICKER_DISPLAY_NAME = "$USDC";
export const FOCUS_TICKER_DISPLAY_NAME = "$FOCUS";
export const DUSD_TICKER_DISPLAY_NAME = "USD";
export const USDT = "USDT";
export const BONDING_CURVE_DISPLAY_NAME = "Bonding Curve";
export const BONDING_CURVE_SHORTHAND_DISPLAY_NAME = "BC";
export const ENABLE_GRAPHQL_BATCH_LINK = false;

export const ANONYMOUS_USERNAME = "anonymous";

export const TOKEN_ICON_FOCUS = "/assets/coin-focus.png";
export const WHALE_ICON = "/assets/cropped-whale-small.webp";

export const LOCAL_STORAGE_KEYS = {
  theme: "focus-app/theme/v1",
};

export const THEME_COOKIE_KEY = "theme";
export const CUSTOM_COLOR_COOKIE_KEY = "custom-color";

export const COMING_SOON_LABEL = "Coming soon!";

export const MIN_WHALE_USD_BALANCE = 1000;
export const MIN_WHALE_USD_CENTS_BALANCE = MIN_WHALE_USD_BALANCE * 100;

export enum THEME_OPTIONS {
  lightMode = "light",
  darkMode = "dark",
  paperLightMode = "paper-light",
  paperDarkMode = "paper-dark",
  modernLightMode = "modern-light",
  modernDarkMode = "modern-dark",
}

export const THEME_COLORS: Record<THEME_OPTIONS, string> = {
  [THEME_OPTIONS.lightMode]: "#000",
  [THEME_OPTIONS.darkMode]: "#fff",
  [THEME_OPTIONS.paperLightMode]: "#caaf38",
  [THEME_OPTIONS.paperDarkMode]: "#caaf38",
  [THEME_OPTIONS.modernLightMode]: "#59b4ff",
  [THEME_OPTIONS.modernDarkMode]: "#59b4ff",
};

export const THEME_COLOR_PRESET = [
  "#e00000", // red
  "#ff4d00", // orange
  "#f2c80d", // yellow
  "#34c759", // green
  "#59b4ff", // blue
  "#c95cff", // purple
  "#ff5370", // pink
  "#b3bfd0", // slate
];

export enum EMOJIS {
  dollar = "💲",
  money = "💵",
  whale = "🐳",
}

export const DESO_SUPPORT_EMAIL = "support@deso.org";

export const TWITTER_URL = "https://twitter.com";

export const WHITEPAPER_DOC_URL = "https://docs.deso.org/focus";
export const DESO_DOC_URL = "https://docs.deso.org";
export const DESO_WEBSITE = "https://deso.com";
export const TOKENOMICS_DOC_URL =
  "https://docs.deso.org/focus/focus-tokenomics";
export const TOKEN_MECHANICS_DOC_URL =
  "https://docs.deso.org/focus/next-generation-token-mechanics";
export const LAUCHING_TOKEN_DOC_URL =
  "https://docs.deso.org/focus/next-generation-token-mechanics/launching-your-token";
export const FOCUS_TERMS_OF_SERVICE_URL =
  "https://docs.google.com/document/d/e/2PACX-1vTiZV1W5SbCQSAYr7Ve-yuhwVbGZj2LGf_ZaZsUDIhW-9ZFfIZqZfsfyFTwiLqZJgg4p9wYZMW0-RtQ/pub";

// TODO: should be fetched from the API
export const TEST_REFERRAL_CODE = "R35EC2";

export const GLOBAL_DESO_LIMIT_BUFFER = 100000000;

export const MOBILE_WIDTH_BREAKPOINT = 768;
export const LARGE_WIDTH_BREAKPOINT = 1024;

export const DEFAULT_PROFILE_PIC =
  "data:image/png;base64,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";

export const MIN_FEE_RATE_NANOS_PER_KB = 1000;
export const MIN_DESO_NANOS_FOR_SUBSCRIPTION_FEES =
  MIN_FEE_RATE_NANOS_PER_KB * 5;
export const DEFAULT_CREATOR_BASIS_POINTS = 10000;
export const DEFAULT_STAKE_MULTIPLE_BASIS_POINTS = 12500;

export interface SocialNetwork {
  name: string;
  icon: IconType;
  url: string;
}

export enum SocialNetworkType {
  twitter = "x.com",
  instagram = "instagram",
  youtube = "youtube",
  twitch = "twitch",
}

export enum SOCIALS_LIST {
  TWITTER = "TWITTER",
  YOUTUBE = "YOUTUBE",
  INSTAGRAM = "INSTAGRAM",
  TWITCH = "TWITCH",
}

export const SocialNetworkMap = {
  [SocialNetworkType.twitter]: {
    name: "x.com",
    url: "https://x.com",
    displayName: "x.com (Twitter)",
    value: "Twitter",
    icon: FaXTwitter,
  },
  [SocialNetworkType.instagram]: {
    name: "Instagram",
    url: "https://instagram.com",
    displayName: "Instagram",
    value: "Instagram",
    icon: FaInstagram,
  },
  [SocialNetworkType.youtube]: {
    name: "Youtube",
    url: "https://www.youtube.com/",
    displayName: "Youtube",
    value: "Youtube",
    icon: FaYoutube,
  },
  [SocialNetworkType.twitch]: {
    name: "Twitch",
    url: "https://www.twitch.tv/",
    displayName: "Twitch",
    value: "Twitch",
    icon: FaTwitch,
  },
};

export enum ProfileSocials {
  TWITTER = "Twitter",
  INSTAGRAM = "Instagram",
  YOUTUBE = "YouTube",
  TWITCH = "Twitch",
}

export const ProfileSocialsMap = {
  [ProfileSocials.TWITTER]: SocialNetworkMap[SocialNetworkType.twitter],
  [ProfileSocials.INSTAGRAM]: SocialNetworkMap[SocialNetworkType.instagram],
  [ProfileSocials.YOUTUBE]: SocialNetworkMap[SocialNetworkType.youtube],
  [ProfileSocials.TWITCH]: SocialNetworkMap[SocialNetworkType.twitch],
};

export const BONUSES_SCHEDULE = [
  "2024-01-11T11:11:00-05:00", // January 11, 2024, 11:11 AM Eastern Time
  "2024-01-18T11:11:00-05:00",
  "2024-01-25T11:11:00-05:00",
  "2024-02-01T11:11:00-05:00",
  "2024-02-08T11:11:00-05:00",
  "2024-02-15T11:11:00-05:00",
  "2024-02-22T11:11:00-05:00",
  "2024-02-29T11:11:00-05:00",
  "2024-03-07T11:11:00-05:00",
  "2024-03-14T11:11:00-04:00", // Note: Daylight Saving Time starts on March 10, 2024
  "2024-03-21T11:11:00-04:00",
  "2024-03-28T11:11:00-04:00",
  "2024-04-04T11:11:00-04:00",
  "2024-04-11T11:11:00-04:00",
  "2024-04-18T11:11:00-04:00",
  "2024-04-25T11:11:00-04:00",
  "2024-05-02T11:11:00-04:00",
  "2024-05-09T11:11:00-04:00",
  "2024-05-16T11:11:00-04:00",
  "2024-05-23T11:11:00-04:00",
  "2024-05-30T11:11:00-04:00",
  "2024-06-06T11:11:00-04:00",
  "2024-06-13T11:11:00-04:00",
];

export enum APP_ROUTES {
  app = "/",
  admin = "/admin",
  dialog = "/dialog",
  post = "/post",
  wallet = "/wallet",
  discover = "/discover",
  notifications = "/notifications",
  messages = "/messages",
  earnings = "/earnings",
  trade = "/trade",
  tradeTrending = "/trade/trending",
  tradeActivity = "/trade/activity",
  tradeTopTraders = "/trade/top-traders",
  tradePortfolio = "/trade/portfolio",
  tradeLaunchpad = "/trade/launchpad",
  tradeLaunch = "/trade/launch",
  tradeLaunchNew = "/trade/launch/new",
  feedStore = "/feed/store",
  bounty = "/bounty",
  collections = "/collections",
  settings = "/settings",
  settingsProfile = "/settings/profile",
  settingsTradeCoin = "/settings/trade-coin",
  settingsReferralCodes = "/settings/referral-codes",
  settingsVerification = "/settings/verification",
  twitterCallback = "/twitter-callback",
  onboardingTwitterCallback = "/onboarding-twitter-callback",
  analyzeFollowers = "/bounty/analyze",
  signUp = "/signup",
  signUpConnectAndEarn = "/signup/connect-and-earn",
  buyAllocation = "/buy/allocation",
  settingsSocials = "/settings/socials",
  jwt = "/jwt",
  blockedUsers = "/settings/blocked-users",
  apiNotificationsTemplate = "/client-api/notifications/template",
}

export const PUBLIC_ROUTES = [
  APP_ROUTES.signUp,
  APP_ROUTES.bounty,
  APP_ROUTES.twitterCallback,
  APP_ROUTES.onboardingTwitterCallback,
  APP_ROUTES.buyAllocation,
  APP_ROUTES.jwt,
  APP_ROUTES.apiNotificationsTemplate,
];

export enum USERSTATUS {
  onboarding = "ONBOARDING",
  active = "ACTIVE",
}

export enum AssociationType {
  reaction = "REACTION",
  pollResponse = "POLL_RESPONSE",
  pinnedPost = "PINNED_POST",
  block = "BLOCK",
  unblock = "UNBLOCK",
  pin = "PIN",
  focusFeed = "FOCUS_FEED",
  FOCUS_FEED_ACTIVE_SUBSCRIPTION = "FOCUS_FEED_ACTIVE_SUBSCRIPTION",
  DeSoTokenWhitelistAssociationKey = "DeSoTokenWhitelistAssociationKey",
  diamond = "DIAMOND",
  pinnedTabAssociationType = "PinnedTabAssociationType",
  collection = "COLLECTION",
}

export enum AssociationReactionValue {
  LIKE = "LIKE",
  DISLIKE = "DISLIKE",
  LOVE = "LOVE",
  LAUGH = "LAUGH",
  ASTONISHED = "ASTONISHED",
  SAD = "SAD",
  ANGRY = "ANGRY",
}

export enum AssociationReactionValueEmojiMap {
  LIKE = "👍",
  DISLIKE = "👎",
  LOVE = "❤️",
  LAUGH = "😂",
  ASTONISHED = "😲",
  SAD = "😢",
  ANGRY = "😠",
}

export enum REWARD_CLAIM_REJECTION_REASONS {
  POST_DELETED = "POST_DELETED",
  SUSPECTED_BOT_ACTIVITY = "SUSPECTED_BOT_ACTIVITY",
  INVALID_REWARD_OFFERED = "INVALID_REWARD_OFFERED",
  UNSPECIFIED = "UNSPECIFIED",
}

export enum AssociationDeSoTokenWhitelistValue {
  DeSoTokenWhitelistAssociationKey = "DeSoTokenWhitelistAssociationKey",
}

export enum AssociationPinValue {
  PIN = "PIN",
}

export enum TabState {
  active = "active",
  inactive = "inActive",
  none = "none",
}

export const ANALYZE_PROGRESS_POLLING_INTERVAL = 2000;

export const KBs_PER_TRANSFER = 0.2;

export const URL_REGEXP =
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s)>]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s)>]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s)>]{2,}|www\.[a-zA-Z0-9]+\.[^\s)>]{2,})/gi;

export const GRAPH_TYPE_POLICIES = {
  Follow: {
    keyFields: ["followerPkid", "followedPkid"],
  },
  UserAssociation: {
    keyFields: ["associationId"],
  },
  Post: {
    keyFields: ["postHash"],
  },
  PostAssociation: {
    keyFields: ["associationId"],
  },
  Account: {
    keyFields: ["publicKey"],
  },
  Profile: {
    keyFields: ["publicKey"],
  },
  DesoBalance: {
    keyFields: ["publicKey"],
  },
  PostTotalDiamondValue: {
    keyFields: ["postHash"],
  },
  Transaction: {
    keyFields: ["transactionHash"],
  },
  TokenBalance: {
    keyFields: ["id"],
  },
  AccessGroup: {
    keyFields: ["id"],
  },
  CreatorStat: {
    keyFields: ["id"],
  },
  AccountWealth: {
    keyFields: ["publicKey"],
  },
  PostView: {
    keyFields: ["postHash"],
  },
  TokenMetadatum: {
    keyFields: ["publicKeyBase58Check"],
  },
  DaoCoinStat: {
    keyFields: ["coinPublicKey"],
  },
};

export enum TransactionType {
  BASIC_TRANSFER = 2,
  DAO_COIN_TRANSFER = 25,
}

export const DEFAULT_MESSAGING_GROUP_KEY_NAME = "default-key";

export const DEFAULT_GROUP_NAMES = [
  "Global Parameters",
  "Negative Interactions",
  "Neutral Reactions",
  "Positive Interactions",
];

export const POST_LIMIT = 20;

export enum CREATOR_COIN_TYPES {
  creator = "creator",
  meme = "meme",
  custom = "custom",
}

export enum META {
  title = `${APP_NAME_GENERIC} | The Crypto Social Network`,
  description = `${APP_NAME_GENERIC} is a new type of social network that mixes crypto speculation, social media, and generative AI. ${APP_NAME_GENERIC} is built from the ground up on the state-of-the-art Decentralized Social blockchain (${DESO_APP_NAME})`,
}

export const ACCOUNT_USERNAMES_WITH_DISABLED_FOCUS_MARKET = [
  "dusdc_",
  "dbtc_",
  "dsol_",
  "deth_",
  "focus",
  "openfund",
];

export const DESO_FOUNDATION_TOKENS = {
  [process.env.NEXT_PUBLIC_OPENFUND_PROFILE_PUBLIC_KEY]: OPENFUND_APP_NAME,
  [process.env.NEXT_PUBLIC_FOCUS_APP_PUBLIC_KEY]: FOCUS_TOKEN_DISPLAY_NAME,
  [process.env.NEXT_PUBLIC_DESO_ZERO_PUBLIC_KEY]: DESO_TOKEN_DISPLAY_NAME,
};

export const DESO_WRAPPED_ASSETS = {
  [process.env.NEXT_PUBLIC_DUSD_PUBLIC_KEY]: USDC_DISPLAY_NAME,
  [process.env.NEXT_PUBLIC_DESO_BTC_PUBLIC_KEY]: BTC_DISPLAY_NAME,
  [process.env.NEXT_PUBLIC_DESO_ETH_PUBLIC_KEY]: ETH_DISPLAY_NAME,
  [process.env.NEXT_PUBLIC_DESO_SOL_PUBLIC_KEY]: SOL_DISPLAY_NAME,
};

export const TRADE_EXCLUDED_PUBLIC_KEYS = [
  "tBCKUrnt5YJEW3J5nJGEP4NDCrZ269gKq6RUeDiYHKds8ZZiDTac4T",
  "tBCKUvR7dZ2KZgDZ7DBvCY91GHA8kMVFt4Qx7fCWkQmhpGKZ55SCjK",
  "tBCKUzAL8D89KXFnNQMKs6qivWKdu9V9i3RudsWPJ45AphQJciWUuV",
  "tBCKVERmG9nZpHTk2AVPqknWc1Mw9HHAnqrTpW1RnXpXMQ4PsQgnmV",
  "tBCKVkgPxvAUrBw5qHqSLsKJERccZ9kk5PAJMABQA6pE28M9dhWBKT",
  "tBCKW665XZnvVZcCfcEmyeecSZGKAdaxwV2SH9UFab6PpSRikg4EJ2",
  "tBCKWdjTmnZYcjo1sBRcgRHYXQc8x5SV9BE8pdfh1xWVuw8MF7ikxb",
  "tBCKWpz71ePCdpmddmE4RtDZsfVHjRJQpSgmfJ6W8sxpDVkQJS5Gdj",
  "tBCKWZMxPsaUMKEueeZJA6PAjrYVwnDGtyo2QRzaxjyoQxs7urizcx",
  "tBCKX1RURo8HRUcYVNrpYj1JZcY1yvWuhSi6NDfKXRudwQpDkAd8YC",
  "tBCKXiEZE1bu8KZahgJXn2z69GCmb14VuuSeAAcS3frXLz6eD44hhP",
  "tBCKXPkEqTvDqJ6wcEFecQt6AKz5WbhunMfMWqvC4ZRP3KvyU5JqPV",
  "tBCKXsFPDRq6ptC82seVtqZfWk9QotzqLH7phazqk9hTeRdqXmSF2a",
  "tBCKXwfxDeCmsEMrmV8eVEpxRcrHYqEYiMyZy2qfFKuReAecCpaSKG",
  "tBCKYa3JPojh7v58RuVsvSS6GgdpBUVrCj6KJ1UAMH9HvwDiWzjMtf",
  "tBCKYEHvdmBS5sXmnkgXjuSadeTb3cm2yqSEFgPHkeyaDTKEXyTBNN",
  "tBCKYHYnKSXxmXWKcAfQHFVZaQDmPqgKeMHD2gskaXFgDGyN9Avmoo",
  "tBCKYKjjmb2ne4g2CzhYAt8ibk58tnmDASSLgbv2ypifjTju3nGGpW",
  "tBCKXLHHh6mqaHaPBBqPR3Uz5xrgHdFTT5ypny8pNnUte9PEHUq1eT",
];

export const MIN_WHALE_BALANCE_USD_CENTS = 1000000;

export const MIN_DESO_TOKEN_PCT_CHANGE_TO_HIGHLIGHT_TRENDING = 0.01;

export const DEFAULT_REPORT_TYPE = "REPORT";

type GetReportLabelProps = {
  isBlacklisted?: boolean;
  isGreylisted?: boolean;
  isNSFW?: boolean;
  hiddenFromForYou?: boolean;
  allowReverse?: boolean;
  isVerified?: boolean;
  isSpam?: boolean;
  isBot?: boolean;
  isNFT?: boolean;
  isOther?: boolean;
};

export const USER_REPORT_TYPE = {
  GREYLIST: {
    public: false,
    value: "GREYLIST",
    getLabel({ isGreylisted, allowReverse }: GetReportLabelProps) {
      return isGreylisted && allowReverse
        ? "Unmark user as Greylisted"
        : "Mark user as Greylisted";
    },
    shouldReverse({ isGreylisted, allowReverse }: GetReportLabelProps) {
      return isGreylisted && allowReverse;
    },
  },
  BLACKLIST: {
    value: "BLACKLIST",
    public: false,

    getLabel({ isBlacklisted, allowReverse }: GetReportLabelProps) {
      return isBlacklisted && allowReverse
        ? "Unmark user as Blacklisted"
        : "Mark user as Blacklisted";
    },
    shouldReverse({ isBlacklisted, allowReverse }: GetReportLabelProps) {
      return isBlacklisted && allowReverse;
    },
  },
  NSFW: {
    public: true,
    value: "NSFW",
    getLabel({ isNSFW, allowReverse }: GetReportLabelProps) {
      return isNSFW && allowReverse
        ? "Unmark user as NSFW"
        : "Mark user as NSFW";
    },
    shouldReverse({ isNSFW, allowReverse }: GetReportLabelProps) {
      return isNSFW && allowReverse;
    },
  },
  VERIFIED: {
    public: false,
    value: "VERIFIED",
    getLabel({ isVerified, allowReverse }: GetReportLabelProps) {
      return isVerified && allowReverse
        ? "Unmark user as Verified"
        : "Mark user as Verified";
    },
    shouldReverse({ isVerified, allowReverse }: GetReportLabelProps) {
      return isVerified && allowReverse;
    },
  },
  SPAM: {
    public: true,
    value: "SPAM",
    getLabel({ allowReverse }: GetReportLabelProps) {
      return allowReverse ? "Unmark user as Spam" : "Mark user as Spam";
    },
    shouldReverse({ isSpam, allowReverse }: GetReportLabelProps) {
      return isSpam && allowReverse;
    },
  },
  BOT: {
    public: true,
    value: "BOT",
    getLabel({ isBot, allowReverse }: GetReportLabelProps) {
      return isBot && allowReverse ? "Unmark user as Bot" : "Mark user as Bot";
    },
    shouldReverse({ isBot, allowReverse }: GetReportLabelProps) {
      return isBot && allowReverse;
    },
  },
  NFT: {
    public: true,
    value: "NFT",
    getLabel({ isNFT, allowReverse }: GetReportLabelProps) {
      return isNFT && allowReverse ? "Unmark user as NFT" : "Mark user as NFT";
    },
    shouldReverse({ isNFT, allowReverse }: GetReportLabelProps) {
      return isNFT && allowReverse;
    },
  },
} as const;

export const PUBLIC_USER_REPORT_TYPE = Object.fromEntries(
  Object.entries(USER_REPORT_TYPE).filter(([, value]) => value.public === true),
);

export const POST_REPORT_TYPE = {
  NSFW: {
    public: true,
    value: "NSFW",
    getLabel({ isNSFW, allowReverse }: GetReportLabelProps) {
      return isNSFW && allowReverse
        ? "Unmark post as NSFW"
        : "Mark post as NSFW";
    },
    shouldReverse({ isNSFW, allowReverse }: GetReportLabelProps) {
      return isNSFW && allowReverse;
    },
  },
  HIDE_FROM_FOR_YOU: {
    public: false,
    value: "HIDE_FROM_FOR_YOU",
    getLabel({ hiddenFromForYou, allowReverse }: GetReportLabelProps) {
      return hiddenFromForYou && allowReverse
        ? "Show post in For You feed"
        : "Hide post from For You feed";
    },
    shouldReverse({ hiddenFromForYou, allowReverse }: GetReportLabelProps) {
      return hiddenFromForYou && allowReverse;
    },
  },
  SPAM: {
    public: true,
    value: "SPAM",
    getLabel({ isSpam, allowReverse }: GetReportLabelProps) {
      return isSpam && allowReverse
        ? "Unmark post as Spam"
        : "Mark post as Spam";
    },
    shouldReverse({ isSpam, allowReverse }: GetReportLabelProps) {
      return isSpam && allowReverse;
    },
  },
  BOT: {
    public: true,
    value: "BOT",
    getLabel({ isBot, allowReverse }: GetReportLabelProps) {
      return isBot && allowReverse ? "Unmark post as Bot" : "Mark post as Bot";
    },
    shouldReverse({ isBot, allowReverse }: GetReportLabelProps) {
      return isBot && allowReverse;
    },
  },
  NFT: {
    public: true,
    value: "NFT",
    getLabel({ isNFT, allowReverse }: GetReportLabelProps) {
      return isNFT && allowReverse ? "Unmark post as NFT" : "Mark post as NFT";
    },
    shouldReverse({ isNFT, allowReverse }: GetReportLabelProps) {
      return isNFT && allowReverse;
    },
  },
} as const;

export const PUBLIC_POST_REPORT_TYPE = Object.fromEntries(
  Object.entries(POST_REPORT_TYPE).filter(([, value]) => value.public === true),
);

export const MAX_VIDEO_SIZE_BYTES = 2_147_483_648;
export const MAX_VIDEO_SIZE_TEXT = "2GB";

export const MAX_VIDEO_LENGTH_SECONDS = 1800;
export const MAX_VIDEO_LENGTH_TEXT = "30 minutes";

export const MAX_AUDIO_LENGTH_SECONDS = 10800;
export const MAX_AUDIO_LENGTH_TEXT = "3 hours";

export const MAX_IMAGE_SIZE_BYTES = 104_857_600;
export const MAX_IMAGE_SIZE_TEXT = "100MB";

export const RESERVED_DESO_NANOS_FOR_FEES = 50000;

export const FOCUS_LAUNCH_DATE = "2025-01-30T19:00:00+00:00";

export const FOCUS_TOKEN_SUPPLY = 44_663_577_756;

export const DESO_DENOMINATED_TOKENS = [
  process.env.NEXT_PUBLIC_OPENFUND_PROFILE_PUBLIC_KEY,
  process.env.NEXT_PUBLIC_FOCUS_APP_PUBLIC_KEY,
];

export const PINNED_TOKEN_PUBLIC_KEYS = [
  "BC1YLgojxb6ubd1EGFUo8JHNcD55CEDdtcm8HSi7scivnjyqZzTUZeT",
];

export enum AutoplayType {
  NEVER,
  ALWAYS,
  ON_INTERSECTION,
}
